export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Audio Player';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Audio source';

  const media = document.createElement('div');
  media.className = 'ew-media';

  const audio = document.createElement('audio');
  audio.controls = node.props?.controls !== false;
  audio.loop = Boolean(node.props?.loop);
  audio.autoplay = Boolean(node.props?.autoplay);
  audio.muted = Boolean(node.props?.muted);

  const applySource = (src) => {
    media.innerHTML = '';
    if (!src) {
      media.appendChild(makePlaceholder('No audio source'));
      return;
    }
    audio.src = src;
    media.appendChild(audio);
  };

  applySource(node.data?.src || node.props?.src || '');

  audio.addEventListener('ended', () => {
    api.emit('node:input', { id: node.id, field: 'ended', value: true });
  });

  body.append(label, media);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      title.textContent = next.props?.title || 'Audio Player';
      label.textContent = next.props?.label || 'Audio source';
      audio.controls = next.props?.controls !== false;
      audio.loop = Boolean(next.props?.loop);
      audio.autoplay = Boolean(next.props?.autoplay);
      audio.muted = Boolean(next.props?.muted);
      const src = next.data?.src || next.props?.src || '';
      if (audio.getAttribute('src') !== src) applySource(src);
    }
  };
}

function makePlaceholder(text) {
  const el = document.createElement('div');
  el.className = 'ew-media-placeholder';
  el.textContent = text;
  return el;
}
